<template>
    <Modal :backdrop="backdrop" :visible="visible">
        <template #header>
            <div class="text-center mb-5">{{Title}}</div>
        </template>
        <template #main>
            <div class="text-center font-bold text-2xl mb-5">
                {{Main}}
            </div>
        </template>
        <template #footer>
            <div  v-if="riepilogo" class="flex justify-center pt-3">
                <NextButton variant="primary"
                    @click="$emit('close')"
                    class="ml-4 py-2 px-4">
                    Chiudi
                </NextButton>
            </div>
            <div v-else class="flex justify-center pt-3">
                <NextButton variant="outline-secondary"
                    @click="$emit('confirm')"
                    class="col-start-3 py-2 px-4">
                    {{ buttonLabel }}
                </NextButton>
                <NextButton variant="primary"
                    @click="$emit('reject')"
                    class="ml-4 py-2 px-4">
                    Chiudi
                </NextButton>
            </div>

        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'CambiaStatoAlertModal',
    components:{
        NextButton,
      Modal
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        backdrop: {
            type: Boolean,
            default: false
        },
        riepilogo: Boolean,
        abilitato: [Boolean,Number,String]
    }
})
export default class CambiaStatoAlertModal extends Vue {
    visible!: boolean
    riepilogo!: boolean
    abilitato!: boolean | number | string

    get Title(){
        if(this.riepilogo){
            if(this.isAbilitato){
                return 'Puoi disattivare gli alert automatici in qualsiasi momento dalla pagina Attività.'
            }
            return 'Puoi riabilitare gli alert automatici in qualsiasi momento dalla pagina Attività.'
        } else if(this.isAbilitato){
            return 'Disattivando gli alert automatici verranno disattivate tutte le notifiche riguardanti il progetto.'
        }
        return 'Abilitando gli alert automatici verranno abilitate tutte le notifiche riguardanti il progetto.'
    }

    get Main(){
        if(this.riepilogo){
            if(this.isAbilitato){
                return 'Gli alert automatici sono stati abilitati.'
            }
            return 'Gli alert automatici sono stati disabilitati.'
        } else if(this.isAbilitato) {
            return 'Vuoi disattivare gli alert automatici per questo progetto?'
        }
        return 'Vuoi abilitare gli alert automatici per questo progetto?'
    }

    get buttonLabel(){
        return this.isAbilitato? 'Disabilita': 'Abilita';
    }

    get isAbilitato() {
        return this.abilitato != '0'
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
